var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_SmartPhone_M",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M30 14 28 14 28 82.022 68 82.022 68 14 30 14ZM66 80.022 30 80.022 30 16 66 16Z",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M71 4 25 4C23.8968 4.00329 23.0033 4.8968 23 6L23 90.025C23.0038 91.128 23.897 92.0212 25 92.025L71 92.025C72.1027 92.0206 72.9956 91.1277 73 90.025L73 6C72.9962 4.89703 72.103 4.00384 71 4ZM71 90.025 25 90.025 25 6 71 6Z",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M44 11 53 11C53.5523 11 54 10.5523 54 10 54 9.44771 53.5523 9 53 9L44 9C43.4477 9 43 9.44771 43 10 43 10.5523 43.4477 11 44 11Z",
    stroke: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidPhone);
export default __webpack_public_path__ + "static/media/AndroidPhone.0d36c0e85a62785d3c1435ed6dd3d3e5.svg";
export { ForwardRef as ReactComponent };